import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { ProjectDirectoryLayout } from '@adsk/alloy-project-page-layout';
import { useAlloyFeatureFlag } from '@adsk/alloy-provider';
import ProjectsHeader from './ProjectsHeader';
import AlloyContextSubscriber from '../../components/AlloyContextSubscriber';
import RemoteComponent from '../../components/RemoteComponent/RemoteComponent';
import RouteTitle from '../../components/RouteTitle/RouteTitle';
import { DEFAULT_TITLE } from '../../consts';
import { RemoteProjectList } from '../../envs/types';
import useRemotes from '../../hooks/useRemotes';
import i18n from '../../utils/i18n';

const MainContainerWithoutFilters = styled.div({
  margin: '32px 48px',
});
const MainContainer = styled.div({
  margin: '32px 0',
});

const OutletContainer: FC = () => {
  const remotes = useRemotes();
  const projectListRemote = remotes?.find(
    (r) => r.scope === 'accProjectList'
  ) as RemoteProjectList | undefined;

  const { value: showUserHomeTab, loading: showUserHomeTabLoading } =
    useAlloyFeatureFlag('show-user-home-tab');
  const { value: showFiltersPanel } = useAlloyFeatureFlag('pl_filters_panel');

  const Container = showFiltersPanel
    ? MainContainer
    : MainContainerWithoutFilters;

  const {
    value: showUpdatedProductLinksLayout,
    loading: showUpdatedProductLinksLayoutLoading,
  } = useAlloyFeatureFlag('show-updated-product-links-layout');

  const title = showUserHomeTabLoading
    ? DEFAULT_TITLE
    : showUserHomeTab
    ? DEFAULT_TITLE
    : i18n.t('PROJECT_LIST');

  return (
    <RouteTitle title={title}>
      {showUpdatedProductLinksLayout && projectListRemote && (
        <RemoteComponent
          url={projectListRemote.url}
          scope={projectListRemote.scope}
          module={projectListRemote.modules.productLinksModule}
          renderLoader={() => null}
        />
      )}
      <Container>
        <ProjectsHeader
          showUserHomeTab={showUserHomeTab}
          showUserHomeTabLoading={showUserHomeTabLoading}
          showUpdatedProductLinksLayout={showUpdatedProductLinksLayout}
          showUpdatedProductLinksLayoutLoading={
            showUpdatedProductLinksLayoutLoading
          }
        />
        <Outlet />
      </Container>
    </RouteTitle>
  );
};

const Projects = () => {
  const remotes = useRemotes();
  const projectListRemote = remotes?.find(
    (r) => r.scope === 'accProjectList'
  ) as RemoteProjectList | undefined;

  if (!projectListRemote) {
    return null;
  }

  return (
    <ProjectDirectoryLayout>
      <RemoteComponent
        url={projectListRemote.url}
        scope={projectListRemote.scope}
        module={projectListRemote.modules.providersModule}
      >
        <AlloyContextSubscriber>
          <OutletContainer />
        </AlloyContextSubscriber>
      </RemoteComponent>
    </ProjectDirectoryLayout>
  );
};

export default Projects;
